import { render, staticRenderFns } from "./ChartsWidget.vue?vue&type=template&id=985b5190&scoped=true"
import script from "./ChartsWidget.vue?vue&type=script&lang=js"
export * from "./ChartsWidget.vue?vue&type=script&lang=js"
import style0 from "./ChartsWidget.vue?vue&type=style&index=0&id=985b5190&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985b5190",
  null
  
)

export default component.exports